import { LABELS } from '@/constants/common/message.constants'

import { type UserMeTenantDcExEntity } from '../../aspida/@types'

/**
 * DCロール
 */
export type DcRole = UserMeTenantDcExEntity['role']

export const DC_ROLE = {
  /** 管理者 */
  MANAGER: 'MANAGER',
  /** 担当者 */
  STAFF: 'STAFF'
} as const satisfies Record<DcRole, DcRole>

export const DC_ROLE_LABEL = {
  [DC_ROLE.MANAGER]: LABELS.MANAGER,
  [DC_ROLE.STAFF]: LABELS.DC_ROLE_STAFF
} as const satisfies Record<DcRole, string>
